export interface IBreakpoints {
  MOBILE: string
  MOBILE_PX: number
}

export const breakpoints: IBreakpoints = {
  MOBILE: '600px',
  MOBILE_PX: 600,
}
